import { Theme } from "@amx/ux-twoui-theming";
import { twouiZIndexes } from "@amx/ux-twoui-utils";
import { IPivotStyles } from "@fluentui/react";

export const getTabsStyles = (theme: Theme, separator: boolean, variant: string): Partial<IPivotStyles> => {
    const separatorStyles = separator ? {
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderColor: theme.palette.neutralLight
    } : undefined;

    return {
        root: variant === "centeredWithBackground" ? {
            ...separatorStyles,
            zIndex: twouiZIndexes.twoUITab,
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            background: theme.palette.neutralHigh,
            textAlign: "center",
            paddingTop: "16px",
        } : {
            ...separatorStyles,
            zIndex: twouiZIndexes.twoUITab,  //It should be less than 10 so that Family Left Nav be accessible in mobile viewport when expanded.
        }
    };
};

export const iconStyle = { display: "inline-flex", verticalAlign: "bottom" };
export const defaultRendererStyle = { display: "inline-flex" };
